export default {
  "wrapper": "_wrapper_1cyjsu",
  "animation": "_animation_1cyjsu",
  "hidden": "_hidden_1cyjsu",
  "content": "_content_1cyjsu",
  "title": "_title_1cyjsu",
  "buttons": "_buttons_1cyjsu",
  "image": "_image_1cyjsu",
  "subtitle": "_subtitle_1cyjsu"
};